import React from 'react'

import type { ThemeButtonProps } from '@/components/antd/ThemeButton'

import ThemeButton from '@/components/antd/ThemeButton'

export interface StyledButtonProps extends Omit<ThemeButtonProps, 'theme'> {}

const StyledButton: React.FC<StyledButtonProps> = (props) => {
  return (
    <ThemeButton
      {...props}
      theme={{
        components: {
          Button: {
            defaultBg: `var(--f-bg-hover)`,
            defaultActiveBg: `var(--f-bg-hover)`,
            defaultHoverBg: `var(--f-bg-hover)`,
            defaultHoverColor: `var(--f-primary)`,
            defaultHoverBorderColor: `var(--f-bg-hover)`,
            defaultBorderColor: `var(--f-bg-hover)`,
            defaultActiveBorderColor: `var(--f-bg-hover)`,
          },
        },
      }}
    />
  )
}

export default StyledButton
